export interface OrganizationMissingDataBannerProps {
  incompleteSections: number;
}

export function OrganizationMissingDataBanner({
  incompleteSections,
}: OrganizationMissingDataBannerProps) {
  if (incompleteSections <= 0) return null;

  return (
    <div
      role="note"
      className="flex items-center gap-2 px-4 py-3 mb-4 rounded-[6px] border border-(--border-default) bg-(--bg-canvas) text-[11.5px] text-(--fg-secondary)"
    >
      <span
        className="inline-block w-[7px] h-[7px] rounded-[3px] bg-(--fg-muted) shrink-0"
        aria-hidden
      />
      <span>
        {incompleteSections} section
        {incompleteSections !== 1 ? "s" : ""} with missing data
      </span>
    </div>
  );
}
